import { memo } from 'react'
import Link from 'next/link'
import s from './Header.module.scss'

type IconProps = {
  href: string
  type: string
}

const Icon = memo(({ href = '/', type }: IconProps) => {
  let children
  switch (type) {
    case 'fav':
      children = <div className={s.fav} />
      break
    case 'appNot':
      children = <div className={s.appNot} />
      break
    case 'application':
      children = <div className={s.application} />
      break
    case 'pet':
      children = <div className={s.pet} />
      break
    default:
      children = null
  }

  return <Link href={href}>{children}</Link>
})

export default Icon
